import cn from 'classnames';
import React from 'react';

import styles from './ErrorTextWrapper.module.scss';

type Props = {
  errorText?: React.ReactNode;
  additionalText?: React.ReactNode;
  errorTextPosition?: 'left' | 'right';
} & React.HTMLProps<HTMLDivElement>;

export const ErrorTextWrapper: React.FC<Props> = ({
  errorText,
  className,
  errorTextPosition = 'left',
  additionalText,
  children,
  ...other
}) => {
  return (
    <div
      {...other}
      className={styles.errorTextWrapper}
    >
      {children}
      {errorText && (
        <div className={cn(styles.error, { [styles.error_alignRight]: errorTextPosition === 'right' }, className)}>
          {errorText}
        </div>
      )}
      {!errorText && additionalText && <div className={styles.message}>{additionalText}</div>}
    </div>
  );
};
